import { Api } from '../api';
import { transactions } from '../endpoints';
import type { TransactionEntity, TransactionSearchParams } from './models';

export class TransactionApi extends Api {
  static getTransactions = (searchParams: TransactionSearchParams, signal?: AbortSignal) =>
    this.post<TransactionEntity[]>(transactions.getTransactions(), searchParams, { signal });
}
